const LoadingSpinner = () => (
  <div className="loading-spinner-wrapper">
    <div className="loading-spinner"></div>
  </div>
);

export default LoadingSpinner;
